module.exports = __webpack_public_path__ + "img/github.5ba74703.svg";